import Vue from "vue";
import { get } from "lodash";

/**
 * Common data used by all address search components
 */
export default Vue.extend( {
  props: {
    /**
     * V-model value
     */
    value: {
      type: Object,
      default: () => {}
    },

    /**
     * The selected user type
     */
    userType: {
      type: Object,
      default: () => {}
    },

    /**
     * If true then show validation for each field
     */
    showValidation: {
      type: Boolean,
      default: false
    }
  },

  data () {
    const blankAddress = this.blankAddress();
    return {
      // This is the common address model that all search components
      // will return
      address: blankAddress
    };
  },

  computed: {
    /**
     * The default country ID to use if we don't get supplied with one
     */
    defaultCountryId () {
      return get( this.userType, "defaultCountryId", null );
    },

    /**
     * The default organisation type to use
     */
    defaultOrgTypeId () {
      return get( this.userType, "defaultOrgTypeId", null );
    }
  },

  methods: {
    /**
     * Create a blank address
     */
    blankAddress () {
      const countryId = get( this.userType, "defaultCountryId", null );
      const orgTypeId = get( this.userType, "defaultOrgTypeId", null );

      return {
        id: null,
        orgName: null,
        address1: null,
        address2: null,
        address3: null,
        town: null,
        region: null,
        postcode: null,
        country: null,
        countryId,
        orgTypeId
      };
    }
  }
} );
